import { BaseballTile } from "components/tile-baseball";

export const BaseballTiles = ({ TilesData }) => {
  return (
    <>
      {TilesData?.map((item) => (
        <BaseballTile
          key={item.key}
          title={item.title}
          unit={item.unit}
          value={item.value}
          clubFittingFirstColumn
          isClubFittingScreen
          variant={item.color}
        />
      ))}
    </>
  );
};
